import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-guide-google',
  templateUrl: './guide-google.component.html',
  styleUrls: ['./guide-google.component.scss']
})
export class GuideGoogleComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
